export default {
  title: 'Region',
  NAOnlyMessage: 'Legen Sie Ihre Vorwahl fest. Diese Information wird für Ortsgespräche verwendet.',
  MultiWithNAMessage: 'Legen Sie das Land und die Vorwahl Ihrer Region fest. Diese Information wird für Ortsgespräche und die Formatierung der Telefonnummer verwendet.',
  MultiWithoutNAMessage: 'Wählen Sie das Land aus, in dem Sie sich befinden. Dies wird für Ortsgespräche und die Telefonnummernformatierung verwendet.',
  country: 'Land',
  areaCode: 'Vorwahl',
  areaCodePlaceholder: 'Vorwahl eingeben',
};
